import React, { ChangeEvent } from 'react';
import { useRecoilState } from 'recoil';
import { testIds } from 'src/app/constants';
import { checkExerciseAtom, conversationsAtom } from 'src/app/state/atoms';
import styles from './Prompt.module.scss';
import { t } from 'i18next';

type PromptPropType = {
  handlePromptInput?: (event: ChangeEvent<HTMLInputElement | any>) => void;
  onSubmit?: (event: React.FormEvent<HTMLFormElement> | ChangeEvent<EventTarget>) => void;
  promptValue?: string;
  disabled?: boolean;
  readOnly?: boolean;
};

function Prompt(props: PromptPropType) {
  const [checkExercise] = useRecoilState(checkExerciseAtom);
  const [conversations] = useRecoilState(conversationsAtom);
  const { handlePromptInput, promptValue, disabled, readOnly, onSubmit } = props;

  // Check if the message limit reached
  const messageLimitReached = !!conversations?.data?.is_open_chat_disabled;

  const isDisabled = (): boolean => {
    return (
      disabled ||
      checkExercise?.error?.length > 0 ||
      checkExercise?.data.live_chat_disabled ||
      messageLimitReached
    );
  };

  const getPlaceholder = () => {
    return isDisabled()
      ? messageLimitReached
        ? t('LIVE_CHAT_NOT_AVAILABLE_MESSAGE_LIMIT')
        : t('LIVE_CHAT_NOT_AVAILABLE')
      : t('REPLY_OR_ASK_FOR_HELP');
  };

  // The textarea component can hold multiple lines
  // (just for placeholder text)
  const inputProps = {
    type: 'text',
    autoComplete: 'off',
    value: promptValue,
    id: testIds.promptInput,
    'aria-label': t('REPLY_OR_ASK_FOR_HELP'),
    placeholder: getPlaceholder(),
    className: `px-space-4 w-full text-main text-body-medium ${styles.promptInput}`,
    onChange: handlePromptInput,
    disabled: isDisabled(),
    readOnly: Boolean(readOnly),
    maxLength: 500,
  };

  return (
    <div className={styles.promptContainer}>
      <form onSubmit={onSubmit}>
        {messageLimitReached ? <textarea {...inputProps} /> : <input {...inputProps} />}
      </form>
    </div>
  );
}

export default Prompt;
